import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { API } from '../api/axios';
import { useAuth } from './AuthContext';
const axiosBaseUrl = API.defaults.baseURL;
const GoogleCallback = (props) => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [text, setText] = useState('Loading...');
  const location = useLocation();
  const params = useParams();

  useEffect(() => {
    fetch(`${axiosBaseUrl}/auth/google/callback${location.search}`)
      .then((res) => {
        if (res.status !== 200) {
          throw new Error(`Couldn't login to Strapi. Status: ${res.status}`);
        }
        return res;
      })
      .then((res) => res.json())
      .then((res) => {
        if (res.jwt) {
          login(res.jwt, res.user);
          navigate('/'); // redirect after login
        } else {
          alert('Login failed or token missing');
          navigate('/signin');
        }
      })
      .catch((err) => {
        console.log(err);
        setText('An error occurred, please see the developer console.');
        navigate('/signin');
      });
  }, [location.search, params.providerName]);

  return <p>{text}</p>;
};

export default GoogleCallback;
